import React from 'react'

const BusinessParameter = () => {
  return (
    <div>BusinessParameter</div>
  )
}

export default BusinessParameter